import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "车主意见列表", -1);
const _hoisted_2 = {
  slot: "footer",
  style: {
    "margin-top": "10px",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.business.customerSuggestInfo.getList,
    columns: $data.columns,
    linkButtons: $data.linkButtons,
    searchItems: $data.searchItems,
    selectionEnable: false,
    "row-key": "id",
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "linkButtons", "searchItems"]), _createVNode(_component_el_dialog, {
    title: "意见处理",
    modelValue: $data.makeDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.makeDialog = $event),
    "close-on-click-modal": false,
    "destroy-on-close": "",
    width: "50%"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.makeForm,
      "label-width": "120px",
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "处理结果",
        prop: "memo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.makeForm.memo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.makeForm.memo = $event),
          placeholder: "请输入处理结果",
          autosize: {
            minRows: 2,
            maxRows: 4
          },
          type: "textarea"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = $event => $data.makeDialog = false),
      type: "warning"
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      onClick: $options.doMake,
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode("处理")]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["modelValue"])]);
}